import React, { useState } from 'react';
import './TriggerDrawer.css';

const TriggerDrawer = ({ trigger, onUpdate, onClose }) => {
    const [config, setConfig] = useState(trigger.config);

    const handleSave = () => {
        onUpdate({
            config: config
        });
        onClose();
    };

    const renderSpecificDateTimeConfig = () => (
        <div className="drawer-section">
            <h4>Date and Time Configuration</h4>
            <div className="form-group">
                <label>Date</label>
                <input
                    type="date"
                    value={config.date || ''}
                    onChange={(e) => setConfig({...config, date: e.target.value})}
                    min={new Date().toISOString().split('T')[0]}
                />
            </div>
            <div className="form-group">
                <label>Time</label>
                <input
                    type="time"
                    value={config.time || ''}
                    onChange={(e) => setConfig({...config, time: e.target.value})}
                />
            </div>
            <div className="form-group">
                <label>Timezone</label>
                <select
                    value={config.timezone || ''}
                    onChange={(e) => setConfig({...config, timezone: e.target.value})}
                >
                    <option value="">Select timezone...</option>
                    <option value="UTC">UTC</option>
                    <option value="America/New_York">Eastern Time (ET)</option>
                    <option value="America/Chicago">Central Time (CT)</option>
                    <option value="America/Denver">Mountain Time (MT)</option>
                    <option value="America/Los_Angeles">Pacific Time (PT)</option>
                    <option value="Europe/London">London (GMT)</option>
                    <option value="Europe/Paris">Paris (CET)</option>
                    <option value="Asia/Tokyo">Tokyo (JST)</option>
                    <option value="Asia/Shanghai">Shanghai (CST)</option>
                    <option value="Australia/Sydney">Sydney (AEST)</option>
                </select>
            </div>
        </div>
    );

    return (
        <div className="trigger-drawer-overlay" onClick={onClose}>
            <div className="trigger-drawer" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <h3>Trigger Configuration</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                <div className="drawer-content">
                    <div className="drawer-section">
                        <h4>When should this automation run?</h4>
                        <div className="form-group">
                            <label>Trigger Type</label>
                            <select
                                value={config.triggerType || ''}
                                onChange={(e) => setConfig({...config, triggerType: e.target.value || null})}
                            >
                                <option value="">Select a trigger type...</option>
                                <option value="contact_added">Contact Added</option>
                                <option value="contact_updated">Contact Updated</option>
                                <option value="tag_added">Tag Added</option>
                                <option value="tag_removed">Tag Removed</option>
                                <option value="status_changed">Status Changed</option>
                                <option value="text_message_received">Text Message Received</option>
                                <option value="email_received">Email Received</option>
                                <option value="specific_date_time">On Specific Date and Time</option>
                            </select>
                        </div>
                    </div>
                    
                    {config.triggerType === 'specific_date_time' && renderSpecificDateTimeConfig()}
                </div>
                <div className="drawer-footer">
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TriggerDrawer; 